import {
    ModalContent,
    ModalFooter,
    ModalFooterLeft,
    ModalHeader,
} from '../ModalView'
import Button from '../../Button'
import {EndConversationModalViewProps} from './types'
import {ExclamationIcon} from '../../Icon'
import Modal from '../Modal'
import React from 'react'
import {useTranslation} from 'react-i18next'

const EndConversationModalView = ({
    onClose,
    onCancel,
    onEnd,
}: EndConversationModalViewProps): React.ReactElement => {
    const {t} = useTranslation()

    return (
        <Modal onClose={onCancel}>
            <ModalHeader icon={ExclamationIcon} title={t('Do you wish to end the conversation?')} type='error' />
            <ModalContent>
                <div>{t('End: conversation will end, but tags and notes can still be added')}</div>
                <div>{t('End and close: conversation will end and you cannot add tags or notes anymore')}</div>
            </ModalContent>
            <ModalFooter>
                <ModalFooterLeft>
                    <Button onPress={onCancel} tabIndex={-1} text={t('Cancel')} />
                </ModalFooterLeft>
                <Button onPress={onEnd} tabIndex={-1} text={t('End')} />
                <Button color='filled' margin='left' onPress={onClose} tabIndex={0} text={t('End and close')} />
            </ModalFooter>
        </Modal>
    )
}

export default EndConversationModalView
